import { useQuery } from "react-query";
import { getSubscriptions } from "../api/plans/getSubscriptions";
import { useCurrentAccountStore } from "./currentAccountStore";

/**
 * All subscriptions on the account (normally there's just one).
 */
export const useQuerySubscriptions = () => {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);
  return useQuery(getSubscriptionQueryKey(accountId), () =>
    getSubscriptions(accountId),
  );
};

export function getSubscriptionQueryKey(accountId: string) {
  return ["accounts", accountId, "subscriptions"];
}
